import Base from './base'
import renderFields from './fake-call-declined.pug'

export default class FakeCallDeclined extends Base
  @label: "拒接假電話"

  renderFields: renderFields
